import React, { Component } from 'react'
import { documentsTitles, saved, remote, localstate } from './dynamic_documents';

export class CollectGSTInfo extends Component {
  genStateMonth(month) {
    return ([
      {
        label: "Month",
        name: "monthvalue",
        type: "text",
        defaultValue: month,
        "data-invalue": month,
        readOnly: true,
        required: true
      },
      {
        label: "File Upload",
        name: "gst_info_file",
        outClassName: "col-md-8",
        type: "fileuploader",
        intype: "filepassword",
        uploadpayload: {
          application_id: `{application_id}`,
          doc_meta_name: {
            name: `state.{stateIndex}.months.{monthIndex}.{name}`,
            group: "credit",
            documentKey: `{documentKey}`
          }
        },
        required: true
      }
    ])
  }

  genStateObj(obj = {}) {
    return {
      months: (obj?.months?.length ? obj.months.map(o => new Date(o.year, o.month - 1, 1).getMonthDisplay()) : new Date().lastMonths()).map(month => this.genStateMonth(month)),
    }
  }

  saved(key) {
    return saved(this, key);
  }

  remote(key) {
    return remote(this, key);
  }

  getEditData() {
    let props = this.props;
    let { store } = props;
    let { credit: storeddata = {} } = store;
    return storeddata['remote'] && storeddata['remote'][props.documentKey];
  }

  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("CollectGSTInfo");
    let instatearr = Object.values(this.saved('state') || []).map(v => this.genStateObj(v));
    console.log({ instatearr });
    this.state = {
      instatearr: instatearr.length ? instatearr : [this.genStateObj()],
      fileds: [
        {
          label: "State Name",
          name: "state_name",
          type: "select",
          options: Object.keys(statecity).options(),
          required: true
        },
        {
          label: "GSTIN No.",
          name: "gstin_id",
          type: "text",
          required: true
        },
        // {
        //   label: "No. Of Months",
        //   name: "tenor_in_months",
        //   type: "number",
        //   required: true
        // },

      ]
    };
  }

  updateLocalInStateArr(instatearr=this.state.instatearr) {
    let states = instatearr.map((state, i) => {
      let rstate = this.remote(`state.${i}`) || { state_name: "", gstin_id: "" };
      let lstate = this.saved(`state.${i}`) || { state_name: "", gstin_id: "" };
      let data = state.months.map((v, i) => {
        let rmonth = rstate.months[i] || {};
        let pdata = v.reduce((c, o) => ({ ...c, [o.name]: o.defaultValue || '' }), {});
        let monthv = `01-${pdata.monthvalue}`.date();
        return {
          ...rmonth,
          month: monthv.getMonth() + 1,
          year: monthv.getFullYear()
        }
      });
      return { ...rstate, ...lstate, months: data };
    });
    this.setStateValue(`state`, states);
  }

  addState() {
    let instatearr = this.state.instatearr;
    instatearr.push(this.genStateObj());
    this.setState({
      instatearr
    });
    this.updateLocalInStateArr(instatearr);
  }

  deleteState(stateIndex) {
    let { fileds, instatearr } = this.state;
    let state = this.remote(`state.${stateIndex}`);
    const deleteLocal = () => {
      let instatearr = this.state.instatearr;
      instatearr = instatearr.filter((o, i) => i != stateIndex);
      this.setState({
        instatearr
      });
      this.updateLocalInStateArr(instatearr);
    };
    if (!state?.months?.length) {
      deleteLocal();
    }
  }

  addMonth(index) {
    let instatearr = this.state.instatearr;
    let months = instatearr[index].months;
    let [month] = months[months.length - 1];
    let [newmonth] = new Date(`01-${month.defaultValue}`).lastMonths(1);
    months.push(this.genStateMonth(newmonth));
    instatearr[index].months = months;
    this.setState({
      instatearr
    });
    this.updateLocalInStateArr(instatearr);
  }

  deleteMonth(stateIndex, monthIndex) {
    let gst_info_id = this.saved(`state.${stateIndex}.months.${monthIndex}.gst_info_id`);
    const deleteLocal = () => {
      let instatearr = this.state.instatearr;
      let months = instatearr[stateIndex].months;
      months = months.filter((o, i) => i != monthIndex);
      instatearr[stateIndex].months = months;
      this.setState({
        instatearr
      });
      this.updateLocalInStateArr(instatearr);
    };
    if (gst_info_id) {
      this.api.execApi("deleteGstInfo", {}, {
        gst_info_id
      }).then(() => {
        this.props.onInfoList && this.props.onInfoList();
        deleteLocal();
      });
    } else {
      deleteLocal();
    }
  }

  getFile(name, offsetkey = "", offsetvalue = "") {
    let { props } = this;
    let { docList: uploaded = {} } = props;
    let mydoclist = uploaded[props.documentKey] ?? [];
    return mydoclist.find(o => o.doc_meta_name.name == name && o.doc_meta_name[offsetkey || "offsetvalue"] == offsetvalue);
  }

  getFileAttrs(subkey, offsetkey = "", offsetvalue = "") {
    let { props } = this;
    let file = this.getFile(subkey, offsetkey, offsetvalue);
    return {
      "data-invalue": file?.attachment_id,
      "data-filename": file?.file_name,
      isuploaded: (!!file),
      labelname: file?.file_name
    }
  }

  uploadDocument(event, name, offsetkey = "", offsetvalue = "") {
    let { props } = this;
    let documentKey = this.props.documentKey;
    let input = event.target;
    let [file] = input.files;
    let docmeta = { name, group: "credit", firmType: props.firmType, documentKey: documentKey, offsetkey, [offsetkey || 'offsetvalue']: offsetvalue };
    let payload = {
      application_id: this.props.urlparams.application_id,
      file,
      doc_meta_name: JSON.stringify(docmeta).encode()
    };
    this.api.execApi("postDocument", payload, {}, {
      multipart: true,
      message: "Uploading please wait...",
      onexec: (response) => {
        success("Upload Successfull").promise.then(() => {
          this.props.onFetchDocList && this.props.onFetchDocList();
        });
      }
    });
  }

  setStateValue(key, value) {
    this.store(`credit.state.${this.props.documentKey}.${key}`, value);
  }

  handleInputEvent(e, key, field) {
    console.log({ e, key, field });
    if (field.type == "select") {
      return this.handleSelectEvent(e, key, field);
    }
    mixins.debounce(() => {
      this.setStateValue(key, e.target.value);
      setTimeout(() => {
        let input = document.querySelector(`[name='${e.target.name}']`);
        input && input.focus();
      }, 0);
    });
  }

  handleSelectEvent([value], key) {
    this.setStateValue(key, value.key);
  }

  saveInfo(e, data) {
    console.log({ data, parsedData: parseInput(data) });
    let payload = parseInput(data).state.reduce((o, n) => (
      [...o, ...(n.months ? n.months.map(o => ({
        ...o,
        ...Object.except(n, ['months'])
      })) : [])
      ]), []);
    payload = payload.map((o) => ({
      ...(o.gst_info_id ? { "gst_info_id": o.gst_info_id } : {}),
      "state_name": o.state_name,
      "gstin_id": o.gstin_id,
      "month": new Date(`01-${o.monthvalue}`).getMonth() + 1,
      "year": o.monthvalue.split('-')[1],
      "attachment_id": o.gst_info_file.attachment_id,
      "filename": o.gst_info_file.filename,
      ...(o.gst_info_file.password ? { "password": o.gst_info_file.password } : {})
    }));

    let editData = this.getEditData();
    if (editData.state.length) {
      let promises = payload.map((o, i) => {
        if (o.gst_info_id) {
          return this.api.execApi('putGstInfo', Object.except(o, ['gst_info_id']), {
            gst_info_id: o.gst_info_id
          });
        } else {
          return this.api.execApi('postGstInfo', [Object.except(o, ['gst_info_id'])], {});
        }
      });
      Promise.all(promises).then(() => {
        alert("Info Updated Successfull.").promise.then(() => {
          this.props.onInfoList && this.props.onInfoList();
        });
      });
    } else {
      this.api.execApi("postGstInfo", payload).then(() => {
        alert("Info Updated Successfull.").promise.then(() => {
          this.props.onInfoList && this.props.onInfoList();
        });
      });
    }
  }

  render() {
    let { props, state } = this;
    let { fileds, instatearr } = state;
    return (
      <AppForm onSubmit={(...args) => this.saveInfo(...args)}>
        {
          instatearr.map((istate, k) => (
            <div key={'istate' + k}>
              <div className='row'>
                <div className='col-12 flex'>
                  {
                    (!istate.months.length) && <button type='button' className='btn text-red-500 ml-auto' onClick={() => this.deleteState(k)}>
                      Delete State <i className="fa fa-trash" />
                    </button>
                  }
                </div>
                {
                  fileds.map((obj, i) => (
                    <div key={obj.name} className={Object.className({
                      'col-12': true,
                      [obj.outClassName || 'col-md-4']: true
                    })}>
                      <AppInput
                        {...Object.except(obj, ['outClassName'])}
                        name={`state.${k}.` + obj.name}
                        onChange={(e) => this.handleInputEvent(e, `state.${k}.` + obj.name, obj)}
                        defaultValue={this.saved(`state.${k}.` + obj.name)}
                      />
                    </div>
                  ))
                }
                <div className='col-12'>
                  {istate.months.map((mfileds, i) => (
                    <div className='row' key={'row' + i}>
                      {
                        mfileds.map((obj, j) => (
                          <div key={'col' + j} className={Object.className({
                            'col-12': true,
                            'col-md-4': j == 0,
                            'col-md-7': j != 0,
                          })}>
                            <AppInput
                              {...templateObject(Object.except(obj, ['outClassName']), {
                                stateIndex: k,
                                monthIndex: i,
                                documentKey: props.documentKey,
                                name: obj.name
                              })}
                              name={`state.${k}.months.${i}.` + obj.name}
                            />
                          </div>))
                      }
                      <div className='col hidden'>
                        <input name={`state.${k}.months.${i}.gst_info_id`} type='hidden' value={this.saved(`state.${k}.months.${i}.gst_info_id`)}></input>
                      </div>
                      <div className='col-1 relative'>
                        {
                          <button type='button' className='btn text-red-500 absolute bottom-0 right-0 form-group' onClick={() => this.deleteMonth(k, i)}>
                            <i className="fa fa-trash" />
                          </button>
                        }
                      </div>
                    </div>
                  ))}
                  <div className="row d-flex mb-3 g-3">
                    <div className="col-12">
                      <button className="btn ml-auto text-primary" type="button" onClick={() => this.addMonth(k)}>
                        <i className="fa fa-plus" /> Add Month
                      </button>
                    </div>
                  </div>
                </div>
                <hr />
              </div>
            </div>
          ))
        }
        <div className="row d-flex mb-3 g-3">
          <div className="col-12">
            <button className="btn add-btn ml-auto" type="button" onClick={() => this.addState()}>
              <i className="fa fa-plus" /> Add State
            </button>
          </div>
        </div>
        <div className="row d-flex">
          <div>
            <button
              className="btn add-btn text-dark rounded-pill ml-auto"
            >
              Update
            </button>
          </div>
        </div>
        <hr />
      </AppForm>
    )
  }
}

export default connect(CollectGSTInfo)